import React, {useState} from 'react'
import Breadcrumb, {BreadcrumbType} from '../../components/Breadcrumb'
import {AssetsBox, IconsBox, LeftBox, RightBox} from '../VideoPage/styles'
import AssetsSidenav from '../../components/AssetsSidenav'
import ProvenProcess from '../../../images/icons/new-dashboard/proven-process-icon.svg'
import {getDivisionDetails} from '../../../constants/divisions'
import {FlahshcardBox, ObjectiveText} from './styles'
import {StudyGuide} from '../../../redux/studyGuides'
import {Helmet} from 'react-helmet'
import FlashCards from '../../../pages/FlashCards'
import Loading from '../../../components/Loading'
import {useWindowDimensions} from '../../../hooks/useWindowDimensions'

type Props = {
  studyGuide?: StudyGuide
  studyDay?: string
  flashcardDeckId?: string
}

const View = ({studyGuide, studyDay, flashcardDeckId}: Props) => {
  const {isMobile} = useWindowDimensions()

  const [isExpanded, setIsExpanded] = useState(isMobile ? false : true)

  const breadcrumbs: BreadcrumbType[] = [
    {
      title: studyGuide?.courseTitle ?? '',
      url: `/study-guide/${studyGuide?.id}`,
    },
    {
      title: `Day ${studyDay}`,
      url: `/study-guide/${studyGuide?.id}`,
    },
  ]

  const division = getDivisionDetails(studyGuide?.abbreviation ?? null)

  const currentAsset = studyGuide?.assets
    ? studyGuide.assets[0].flashcard_deck?.find(q => q.id === flashcardDeckId)
    : undefined

  return (
    <>
      <Helmet>
        <title>{`${currentAsset?.assetTitle} | Black Spectacles`}</title>
      </Helmet>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <AssetsBox>
        <LeftBox $isExpanded={isExpanded}>
          <AssetsSidenav
            currentAssetId={flashcardDeckId}
            studyGuide={studyGuide}
            studyDay={Number(studyDay)}
            isExpanded={isExpanded}
            onChangeIsExpanded={(value: boolean) => setIsExpanded(value)}
          />
        </LeftBox>
        <RightBox>
          {!studyGuide || !currentAsset ? (
            <Loading />
          ) : (
            <>
              <IconsBox>
                <img src={division?.icon} alt={division?.name} />
                <img src={ProvenProcess} alt="Proven Process" />
              </IconsBox>
              <ObjectiveText>
                To mark your day as completed, please ensure you've mastered
                every flashcard. Each one brings you closer to your goal!
              </ObjectiveText>
              <FlahshcardBox>
                <FlashCards
                  flashcardDeckId={flashcardDeckId}
                  courseId={studyGuide?.courseId}
                  isStudyGuide={true}
                  assetGlobalId={currentAsset?.assetGlobalId}
                  studyDay={Number(studyDay)}
                />
              </FlahshcardBox>
            </>
          )}
        </RightBox>
      </AssetsBox>
    </>
  )
}

export default View
